import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { UsersBreadcrumb } from '../../../config/BreadcrumbConfig';
import PageHeader from '../../../component/PageHeader';
import useStore from '../../../store';
import ListComponent from './components/ListComponent';
import AddComponent from './components/AddComponent';
import EditComponent from './components/EditComponent';
import DeleteComponent from './components/DeleteComponent';

const AdminUsers = observer(() => {
	const [userAddModal, setUserAddModal] = useState(false);
	const [userEditModal, setUserEditModal] = useState(false);
	const [userDeleteModal, setUserDeleteModal] = useState(false);
	const { ADMINUSER } = useStore();

	const AddUserModal = () => {
		setUserAddModal(true);
	};

	const closeAddModal = () => {
		setUserAddModal(false);
	};

	const openEdit = () => {
		setUserEditModal(true);
	};

	const closeEditModal = () => {
		setUserEditModal(false);
	};

	const openDelete = (data) => {
		setUserDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setUserDeleteModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			ADMINUSER.searchValue = text;
			ADMINUSER.setupGrid(ADMINUSER.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			ADMINUSER.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={UsersBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddUserModal}
					>
						Add User
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent visible={userAddModal} onClose={closeAddModal} />
			<EditComponent visible={userEditModal} onClose={closeEditModal} />
			<DeleteComponent
				visible={userDeleteModal}
				onClose={closeDeleteModal}
			/>
		</div>
	);
});

export default AdminUsers;
